<svg viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">
    <path d="m40 8h12" fill="none" stroke="#c4cefe" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <rect fill="#fff" height="72" rx="2" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" width="50" x="23.5" y="3" />
    <path d="m26.5 13h44a0 0 0 0 1 0 0v58a2 2 0 0 1 -2 2h-40a2 2 0 0 1 -2-2v-58a0 0 0 0 1 0 0z"
        fill="#e3e7fe" />
    <rect fill="#fff" height="14" rx="2" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" width="48" x="34.5" y="65" />
    <circle cx="23.5" cy="71" fill="#fff" r="16" stroke="#6576ff" stroke-linecap="round"
        stroke-linejoin="round" stroke-width="2" />
    <circle cx="23.5" cy="71" fill="#e3e7fe" r="12" />
    <path
        d="m18.44 70h10.12a1.45 1.45 0 0 1 1.44 1.44v5.09a1.45 1.45 0 0 1 -1.44 1.47h-10.12a1.45 1.45 0 0 1 -1.44-1.47v-5.09a1.45 1.45 0 0 1 1.44-1.44z"
        fill="#6576ff" />
    <path d="m20 70v-2.53a3.5 3.5 0 0 1 7 0v2.53" fill="none" stroke="#6576ff"
        stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    <circle cx="23.5" cy="73.23" fill="#fff" r="1.5" />
    <path
        d="m22.5 74.23h2a0 0 0 0 1 0 0v1.24a.76.76 0 0 1 -.76.76h-.47a.76.76 0 0 1 -.76-.76v-1.24a0 0 0 0 1 -.01 0z"
        fill="#fff" />
    <g fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round"
        stroke-width="1.5">
        <path d="m48.5 69.5v5" />
        <path d="m50.5 70.79-4 2.52" />
        <path d="m50.5 73.31-4-2.52" />
        <path d="m57.17 69.5v5" />
        <path d="m59.17 70.79-4 2.52" />
        <path d="m59.17 73.31-4-2.52" />
        <path d="m65.83 69.5v5" />
        <path d="m67.83 70.79-4 2.52" />
        <path d="m67.83 73.31-4-2.52" />
        <path d="m74.5 69.5v5" />
        <path d="m76.5 70.79-4 2.52" />
        <path d="m76.5 73.31-4-2.52" />
    </g>
    <path d="m30.5 36h34v5h-34z" fill="#fff" />
    <path d="m30.5 43.75h34v5h-34z" fill="#fff" />
    <path d="m30.5 50.5h34v7h-34z" fill="#6576ff" />
    <path d="m49.5 52.5-2.75 3-1.25-1.36" fill="none" stroke="#fff" stroke-linecap="round"
        stroke-linejoin="round" />
    <circle cx="48.5" cy="23.5" fill="#c4cefe" r="7.5" />
</svg>